import { Trans } from 'react-i18next'

import { HistoryInfoPageStyles as S } from '~/pages/history/libs/infoPageStyles'
import { earth } from '~/pages/onboarding/introCard/libs/constants'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const GoodCompanyArt = ({ nextPagePath, pageId }: TPageProps) => {
  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: 'Join 200,000+ learners',
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <S.ImageWrapper>
          <img src={earth} alt="Join 200,000+ learners" />
        </S.ImageWrapper>

        <S.Title>
          <Trans ns="art" i18nKey="onboarding.goodCompanyArt.title" />
        </S.Title>

        <S.Subtitle>
          <Trans ns="art" i18nKey="onboarding.goodCompanyArt.subtitle" />
        </S.Subtitle>

        <S.StyledButton type="button" onClick={() => handleContinue('')}>
          <Trans i18nKey="actions.continue" />
        </S.StyledButton>
      </S.StyledContainer>
    </S.Root>
  )
}

export default GoodCompanyArt
